<template>     
     <div>
    <div class="header pb-8 pt-4">
      <b-container fluid>
        <span class="mask bg-info "></span>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col md="12" class="order-xl-1">
         <Home/>
        </b-col>
      </b-row>
    </b-container>
  </div>
  
</template>

<script>
import Home from '@/components/Home/Home.vue';
export default {
components: {
      Home,
    
    },
}
</script>

<style scoped>
</style>
